import { defineMessages } from 'react-intl';

export default defineMessages({
    requiredSignatures: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Required Signatures',
        defaultMessage: 'Required Signatures'
    },
    forms: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Forms',
        defaultMessage: 'Forms'
    },
    signatureTypeMustSelect: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.signatureTypeMustSelect',
        defaultMessage: 'Signature Type must be selected for each form'
    },
    form: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Form',
        defaultMessage: 'Form'
    },
    signatureType: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Signature Type',
        defaultMessage: 'Signature Type'
    },
    actions: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Actions',
        defaultMessage: 'Actions'
    },
    faxNumber: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Fax Number',
        defaultMessage: 'Fax Number'
    },
    enterEmail: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Enter email',
        defaultMessage: 'Enter {name}\'s email'
    },
    sentToMailing: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.sentToMailing',
        defaultMessage: 'This form will be sent to your mailing address.'
    },
    availableForDownload: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.availableForDownload',
        defaultMessage: 'This form will be available for download on next screen.'
    },
    phoneNumberPlaceholder: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.phoneNumberPlaceholder',
        defaultMessage: '(###) ###-####'
    },
    secondaryNamedInsuredEmail: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Secondary Named Insured Email',
        defaultMessage: 'Secondary Named Insured Email'
    },
    excludedDriverEmail: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Excluded Driver Email',
        defaultMessage: 'Excluded Driver Email'
    },
    spouseEmail: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Spouse Email',
        defaultMessage: 'Spouse Email'
    },
    additionalInsuredEmail: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Additional Insured Email',
        defaultMessage: 'Additional Insured Email'
    },
    secondEmail: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Second Email',
        defaultMessage: 'Second Email'
    },
    duplicateEmail: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.duplicateEmail',
        defaultMessage: 'Each customer must have a unique email address.'
    },
    invalidEmail:{
        id:'ml.gateway.quoteandbind.common.requiredSignatures.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    secondMobileNumber: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Secondary Named Insured Mobile Number',
        defaultMessage: 'Secondary Named Insured Mobile Number'
    },
    excludedMobileNumber: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Excluded Driver Mobile Number',
        defaultMessage: 'Excluded Driver Mobile Number'
    },
    enterMobileNumber: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.Enter Mobile Number',
        defaultMessage: 'Enter {name}\'s Mobile Number'
    },
    emailOrMobileRequired: {
        id: 'ml.gateway.quoteandbind.common.requiredSignatures.emailOrMobileRequired',
        defaultMessage: 'Please enter either an email address or mobile number.'
    },
})